// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.article-box[data-v-dfa344ce]  p {\r\n  text-indent: 2em;\n}\n.article-box[data-v-dfa344ce]  p:has(img),\r\n.article-box[data-v-dfa344ce]  p:has(video) {\r\n  text-indent: 0;\n}\n.article-box[data-v-dfa344ce]  img,\r\n.article-box[data-v-dfa344ce]  video,\r\n.article-box[data-v-dfa344ce]  .el-image {\r\n  width: 100% !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
